import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ManageAccountsRoundedIcon from "@mui/icons-material/ManageAccountsRounded";
import LocalPharmacyRoundedIcon from "@mui/icons-material/LocalPharmacyRounded";
import RuleRoundedIcon from "@mui/icons-material/RuleRounded";
import MedicationLiquidRoundedIcon from "@mui/icons-material/MedicationLiquidRounded";
import QuestionAnswerRoundedIcon from "@mui/icons-material/QuestionAnswerRounded";
import InsertChartRoundedIcon from "@mui/icons-material/InsertChartRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import CustomizedSnackBar from "./CustomizedSnackBar";
import { UserContext } from "../app/App";
import UserTable from "../users/UserTable";
import Scenarios from "../scenarios/Scenarios";
import Recipes from "../recipes/Recipes";
import Pharmacies from "../pharmacies/Pharmacies";
import CenteredTabs from "../examinations/Examinations";
import Accordion from "../settings/Accordion";
import WelcomePage from "../welcome/WelcomePage";
import StatsPage from "../statistics/StatsPage";
import HomeIcon from "@mui/icons-material/Home";
import ConfigData from "../config/config.json";

const drawerWidth = 240;
const webserver = ConfigData.WEBSERVER;

export default function ClippedDrawer() {
  const [selected, setSelected] = React.useState("welcome");

  const { user, setUser } = React.useContext(UserContext);

  /*React.useEffect(() => {
    fetch('http://localhost:8080/user/getAll').then((response) => {
      if (response.status === 401) {
        throw new Error('Unauthorized');
      }
      return response;
    }).then((response) => response.json())
    .then((data) => console.log(data))
    .catch((error) => {
      console.log('Problem: ', error);
    });
  });*/
  const MINUTE_MS = 6000;

  useEffect(() => {
    const interval = setInterval(() => {
      fetch(
        webserver.protocol +
          "://" +
          webserver.host +
          ":" +
          webserver.port +
          "/user/getRole",
        { method: "GET", credentials: "include" }
      )
        .then((response) => {
          if (response.status !== 200) {
            throw new Error("Unauthorized");
          }
          return response;
        })
        .then((response) => response.json())
        .then((data) => {
          setUser((prevState) => {
            return {
              name: data.userName,
              authenticated: true,
              role: data.role,
            };
          });
        })
        .catch((error) => {
          setUser({ name: "", authenticated: false, role: "" });
        });
    }, MINUTE_MS);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, [setUser]);

  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
      >
        <Toolbar />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            height: "100%",
            marginTop: 3,
          }}
        >
          {user.role === "BLAK_EMPLOYEE" ? (
            <>
              <List>
                <ListItem key="welcome" disablePadding>
                  <ListItemButton
                    selected={selected === "welcome"}
                    onClick={() => {
                      setSelected("welcome");
                    }}
                  >
                    <ListItemIcon>
                      <HomeIcon />
                    </ListItemIcon>
                    <ListItemText primary="Startseite" />
                  </ListItemButton>
                </ListItem>
                <ListItem key="users" disablePadding>
                  <ListItemButton
                    selected={selected === "users"}
                    onClick={() => {
                      setSelected("users");
                    }}
                  >
                    <ListItemIcon>
                      <ManageAccountsRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Nutzer" />
                  </ListItemButton>
                </ListItem>
                <ListItem key="settings" disablePadding>
                  <ListItemButton
                    selected={selected === "settings"}
                    onClick={() => {
                      setSelected("settings");
                    }}
                  >
                    <ListItemIcon>
                      <SettingsRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Einstellungen" />
                  </ListItemButton>
                </ListItem>
              </List>
              <Divider />
              <List>
                <ListItem key="pharmacies" disablePadding>
                  <ListItemButton
                    selected={selected === "pharmacies"}
                    onClick={() => {
                      setSelected("pharmacies");
                    }}
                  >
                    <ListItemIcon>
                      <LocalPharmacyRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Apotheken" />
                  </ListItemButton>
                </ListItem>
                <ListItem key="examinations" disablePadding>
                  <ListItemButton
                    selected={selected === "examinations"}
                    onClick={() => {
                      setSelected("examinations");
                    }}
                  >
                    <ListItemIcon>
                      <RuleRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Prüfungen" />
                  </ListItemButton>
                </ListItem>
                <ListItem key="scenarios" disablePadding>
                  <ListItemButton
                    selected={selected === "scenarios"}
                    onClick={() => {
                      setSelected("scenarios");
                    }}
                  >
                    <ListItemIcon>
                      <QuestionAnswerRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Szenarien" />
                  </ListItemButton>
                </ListItem>
                <ListItem key="recipes" disablePadding>
                  <ListItemButton
                    selected={selected === "recipes"}
                    onClick={() => {
                      setSelected("recipes");
                    }}
                  >
                    <ListItemIcon>
                      <MedicationLiquidRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Rezepturen" />
                  </ListItemButton>
                </ListItem>
              </List>
              <Divider />
              <List>
                <ListItem key="statistics" disablePadding>
                  <ListItemButton
                    selected={selected === "statistics"}
                    onClick={() => {
                      setSelected("statistics");
                    }}
                  >
                    <ListItemIcon>
                      <InsertChartRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Statistik" />
                  </ListItemButton>
                </ListItem>
              </List>
            </>
          ) : (
            <List>
              <ListItem key="welcome" disablePadding>
                <ListItemButton
                  selected={selected === "welcome"}
                  onClick={() => {
                    setSelected("welcome");
                  }}
                >
                  <ListItemIcon>
                    <HomeIcon />
                  </ListItemIcon>
                  <ListItemText primary="Startseite" />
                </ListItemButton>
              </ListItem>
              <ListItem key="examinations" disablePadding>
                <ListItemButton
                  selected={selected === "examinations"}
                  onClick={() => {
                    setSelected("examinations");
                  }}
                >
                  <ListItemIcon>
                    <RuleRoundedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Prüfungen" />
                </ListItemButton>
              </ListItem>
            </List>
          )}
          <CustomizedSnackBar />
        </Box>
      </Drawer>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, marginTop: 9, height: "100%" }}
      >
        {selected === "welcome" ? (
          <WelcomePage />
        ) : selected === "users" ? (
          <UserTable />
        ) : selected === "scenarios" ? (
          <Scenarios />
        ) : selected === "settings" ? (
          <Accordion />
        ) : selected === "pharmacies" ? (
          <Pharmacies />
        ) : selected === "examinations" ? (
          <CenteredTabs />
        ) : selected === "recipes" ? (
          <Recipes />
        ) : (
          <StatsPage />
        )}
      </Box>
    </Box>
  );
}
